import React from 'react';
import { formatAmount } from '../lib/utils';
import { getTransactionGrossAmount, getTransactionGrossCurrency, MerchantTransactionAmountLike } from '../lib/merchantAmounts';

export const formatMerchantNumber = (value: number | null | undefined, digits = 6): string =>
    typeof value === 'number' && Number.isFinite(value)
        ? value.toLocaleString('ru-RU', { maximumFractionDigits: digits }) : '-';

export const MerchantPaymentAmounts: React.FC<{
    payment: MerchantTransactionAmountLike & { status: string };
}> = ({ payment }) => {
    const gross = getTransactionGrossAmount(payment);
    const currency = getTransactionGrossCurrency(payment);
    return <div className="space-y-1">
        <div className="font-medium">{gross === undefined ? '-' : formatAmount(gross, currency)}</div>
        <div className="text-xs text-gray-500 dark:text-slate-400">Сумма до комиссии</div>
        <div className="text-xs text-gray-600 dark:text-slate-300">
            Курс: 1 USDT = {formatMerchantNumber(payment.exchange_rate)} {currency}
        </div>
        <div className="text-xs text-gray-600 dark:text-slate-300">
            До комиссии: {formatMerchantNumber(payment.amount_usdt_before_fees)} USDT
        </div>
        {payment.status === 'completed' && <div className="text-xs text-gray-600 dark:text-slate-300">
            Комиссия: {formatMerchantNumber(payment.merchant_commission_rate, 4)}% ({formatMerchantNumber(payment.merchant_commission_usdt)} USDT)
        </div>}
    </div>;
};
